import { useCallback } from 'react'

import { ButtonRowInput } from './ButtonRowInput'
import { ButtonRow } from '../types'

export function MultipleButtonRowInput({
  onChange,
  value
}: {
  value: ButtonRow[]
  onChange: (values: ButtonRow[]) => void
}) {
  const onAdd = useCallback(
    (row: ButtonRow) => {
      onChange([...value, row])
    },
    [value, onChange]
  )

  const onUpdate = useCallback(
    (index: number, row: ButtonRow) => {
      const newValue = value.map((value, idx) => {
        if (idx === index) return row
        return value
      })

      onChange(newValue)
    },
    [value, onChange]
  )

  return (
    <div className="flex flex-col gap-4">
      {value.map(function (value, index) {
        return (
          <ButtonRowInput
            key={index}
            onChange={value => onUpdate(index, value)}
            value={value}
          />
        )
      })}
      <ButtonRowInput onChange={onAdd} />
    </div>
  )
}
